import { IconButton } from "@mui/material";
import { FaArrowLeft } from "react-icons/fa";

const ReturnButton = ({ navigateBack }) => {
    return <div>
        <IconButton onClick={navigateBack}><FaArrowLeft /></IconButton>
    </div>
}

export default ReturnButton;